module.exports = __webpack_public_path__ + "static/img/yytx23.40fa789.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx23.png
// module id = 802
// module chunks = 0